/**
 * The console frame on the other side of a preview route. Shared by every
 * `/preview/*` screen, so all of them answer to one allowlist.
 */
import { parseParentOrigins, type PreviewOutboundMessage } from '.';

/**
 * Console origins allowed to drive a preview. Dev builds fall back to the
 * console's dev server so `pnpm dev` works without configuration; a production
 * build without the variable accepts no messages and shows generic copy.
 */
export const PARENT_ORIGINS = parseParentOrigins(
  import.meta.env.FRONTEND_PREVIEW_PARENT_ORIGINS ??
    (import.meta.env.DEV ? 'http://localhost:3000' : ''),
);

/** Post to the parent at every allowed origin; the browser drops the others. */
export function postToParent(message: PreviewOutboundMessage) {
  if (window.parent === window) return;
  for (const origin of PARENT_ORIGINS) {
    window.parent.postMessage(message, origin);
  }
}

/** A message from the framing console — its window, at an allowed origin. */
export function fromParent(event: MessageEvent): boolean {
  return event.source === window.parent && PARENT_ORIGINS.includes(event.origin);
}
